module.exports = __webpack_public_path__ + "static/media/youmaihuixun.aa0267e4.png";